import React from 'react'
import styled from 'styled-components'

import MetricInfoHeader from 'pages/shared/MaintenanceTrend/MetricInfoHeader'
import TrendMetricsOverview from 'pages/shared/MaintenanceTrend/TrendMetricsOverview'

import CollapsiblePanel from 'components/CollapsiblePanel'

import GA4 from 'helpers/ga4'

import { color } from 'styles/colors'

import { DeviceMaintenanceTrendGroup, DeviceMetric } from 'types/DeviceMetric'

type Props = {
  metricAndGroupList: Array<DeviceMaintenanceTrendGroup | DeviceMetric>
  showMetricSelection: boolean
  selectedMetrics: string[],
  handleMetricSelection: (metricName: string) => void
  deviceId: string
  trendName: string
  hideChart: boolean
  hideRanges: boolean
  sendAnalyticsEvents: boolean
  tier?: string | null
}

const TrendOverviewCard = ({
  metricAndGroupList,
  showMetricSelection,
  selectedMetrics,
  handleMetricSelection,
  deviceId,
  trendName,
  hideChart,
  hideRanges,
  sendAnalyticsEvents,
  tier
}: Props) => {
  const sendGA4Event = (action: string) => {
    if (sendAnalyticsEvents) {
      GA4.sendEvent({
        category: 'Maintenance Trends Page',
        action: 'Maintenance Trend Resize',
        label: `${deviceId}, ${trendName}, ${action}, ${tier}`
      })
    }
  }

  return (
    <div>
      {metricAndGroupList.map((metricAndGroupListItem) => {
        if (!metricAndGroupListItem || metricAndGroupListItem.showInTooltip) { return null }
        return (
          <S.CollapsiblePanel
            key={metricAndGroupListItem.name}
            caretVerticalPosition="start"
            open={false}
            expandedCallback={() => sendGA4Event('Expand')}
            collapsedCallback={() => sendGA4Event('Minimize')}
            headerComponent={
              <MetricInfoHeader
                {...{
                  metricAndGroupListItem,
                  showMetricSelection,
                  selectedMetrics,
                  hideChart,
                  handleMetricSelection
                }}
              />
            }
          >
            <TrendMetricsOverview {...{ metricAndGroupListItem }} hideRanges={hideRanges} />
          </S.CollapsiblePanel>
        )
      })
      }

    </div>
  )
}

export default TrendOverviewCard

const S = {
  CollapsiblePanel: styled(CollapsiblePanel)`
    background: ${color('paneBackground')};
    padding: 10px;
  `
}
